import ProductRow from './ProductRow';

export default ProductRow;
